// Client-veilige constanten voor het vakmanportaal.
export const LEAD_PRIJS = 18;
export const MAX_KOPERS = 5;
export const VAKMAN_CATEGORIEEN = [
  "Elektra storingen oplossen",
  "Wit- of bruingoed repareren",
  "Elektra aanleggen",
  "Groepenkast aanleggen of uitbreiden",
  "Databekabeling aanleggen",
  "Laadpaal installeren",
  "Camerabeveiliging",
  "Inbraakbeveiliging (alarmsysteem)",
  "Intercom / videodeurbel",
] as const;
export const OPVOLG_OPTIES = {
  gesproken: "Ja, we hebben gesproken",
  niet_bereikt: "Nee, meerdere keren geprobeerd",
} as const;
export const RECLAMATIE_REDENEN = [
  "Klant onbereikbaar",
  "Onjuiste contactgegevens",
  "Klant heeft geen aanvraag gedaan",
  "Dubbele aanvraag",
  "Anders",
];
